import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import EntryScreen from "@/pages/EntryScreen";
import MenuPage from "@/pages/MenuPage";
import CheckoutPage from "@/pages/CheckoutPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import TrackPage from "@/pages/TrackPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
    return (
        <div className="App">
            <CartProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<MenuPage />} />
                        <Route path="/home" element={<EntryScreen />} />
                        <Route path="/menu" element={<MenuPage />} />
                        <Route path="/checkout" element={<CheckoutPage />} />
                        <Route
                            path="/confirmation/:orderNumber"
                            element={<ConfirmationPage />}
                        />
                        <Route path="/track" element={<TrackPage />} />
                        <Route path="/admin" element={<AdminLogin />} />
                        <Route
                            path="/admin/dashboard"
                            element={<AdminDashboard />}
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster
                    position="top-center"
                    richColors
                    toastOptions={{
                        style: {
                            fontFamily: "Outfit, sans-serif",
                        },
                    }}
                />
            </CartProvider>
        </div>
    );
}

export default App;
